import type {
  CopilotSpaceFreeTextResource,
  CopilotSpaceImageResource,
  CopilotSpaceUploadedTextFileResource,
} from '../../types'
import {Button} from '@primer/react'

import styles from './AttachmentPreview.module.css'
import {downloadFile} from './utils/download-file'

export interface AttachmentPreviewProps {
  attachment: CopilotSpaceFreeTextResource | CopilotSpaceUploadedTextFileResource | CopilotSpaceImageResource | null
}

export function AttachmentPreview({attachment}: AttachmentPreviewProps) {
  if (!attachment) {
    return <p className={styles.attachmentText}>No attachment selected.</p>
  }

  switch (attachment.type) {
    case 'free_text':
      return <p className={styles.attachmentText}>{attachment.text}</p>
    case 'media_content':
      return (
        <div className={styles.attachmentPreviewImage}>
          <img alt={`image: ${attachment.name}`} src={attachment.url} />
          <Button onClick={() => downloadFile(attachment.url, attachment.name)}>Download</Button>
        </div>
      )
    default: // any unexpected attachment type (this case should not normally be hit)
      return <p>No preview available for this attachment.</p>
  }
}
